import { ToastContainer } from "react-toastify"
import ErrorBanner from "../../components/ErrorBanner/ErrorBanner"
import ExpiredTokenAlert from "../../components/ExpiredTokenAlert/ExpiredTokenAlert"
import BackIcon from "../../media/BackIcon"
import DownIcon from "../../media/DownIcon"
import Logo from "../../media/Logo"
import PlusIcon from "../../media/PlusIcon"
import RefreshIcon from "../../media/RefreshIcon"
import SearchIcon from "../../media/SearchIcon"
import ExplorerOption from "./components/ExplorerOption/ExplorerOption"
import useWorkflowFileExplorer from "./useWorkflowFileExplorer"
import "./WorkflowFileExplorer.css"
import UploadIcon from "../../media/UploadIcon"
import ApiSelector from "./components/ApiSelector/ApiSelector"
import HelpIcon from "../../media/HelpIcon"

const WorkflowFileExplorer = () => {

  const [{ 
    explorer,
    selectedExplorerOption,
    showError,
    error,
    search,
    showSignOut,
    account,
    onExpiredTokenConfirm,
    onSelectExplorerOption,
    onLoadMore,
    onLogout,
    onHideError,
    onError
  }] = useWorkflowFileExplorer()

  const supportEmail = "support@subtera.tech";
  const supportSubject = encodeURIComponent("Dashboard Help");
  const supportBody = encodeURIComponent("");

  return (
    <div className="workflow-file-explorer-container">
      <ErrorBanner show={showError} error={error ?? new Error("Failed to fetch")} onClose={onHideError} />
      <div className="workflow-directories-container">
        <Logo />

        <div className="explorer-options-container">
          <div className="explorer-options-section">
            <p className="explorer-options-heading">SHORTCUTS</p>
            {explorer.map((fileExplorer, key) => (
              <ExplorerOption 
                key={key}
                explorerOption={fileExplorer.option}
                onClick={() => onSelectExplorerOption(key)}
                isSelected={key === selectedExplorerOption} 
              />
            ))}
            {explorer[selectedExplorerOption].option.onAdd !== undefined && (
              <div className="explorer-add-button" onClick={explorer[selectedExplorerOption].option?.onAdd ? (e: React.MouseEvent) => explorer[selectedExplorerOption].option?.onAdd?.(e) : undefined}>
                <PlusIcon />
                <p>{explorer[selectedExplorerOption].option.onAddLabel ?? "Add"}</p>
              </div>
            )}
          </div>
          <div>
            <div className="help-section">
              <p className="explorer-options-heading">SUPPORT</p>
              <a href="https://subtera.monday.com/portal" target="_blank">Support Portal</a>
            </div>
            <div className="explorer-info-section">
              <div className="logout-container" onClick={() => onLogout()}>
                <BackIcon />
                <p>Logout</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="workflow-explorer-container">
        <div className="workflow-topbar">
          <div className="refresh-icon" onClick={() => explorer[selectedExplorerOption].onRefresh()}>
            <RefreshIcon />
          </div>

          <h2 className="explorer-title">{explorer[selectedExplorerOption].option.label}</h2>

          <div className="search-container">
            <SearchIcon />
            <input 
              className="search-input"
              type="text"
              placeholder="Search workflows"
              value={search.value}
              onChange={(e) => search.onChange(e.target.value)}
            />
          </div>

          {explorer[selectedExplorerOption].topBarItem !== undefined && (
            <div onClick={(e: React.MouseEvent) => explorer[selectedExplorerOption].topBarItem?.onClick(e)}>
              {explorer[selectedExplorerOption].topBarItem?.icon}
            </div>
          )}
            
          {/* <SortFilter
            label="Filter"
            show={showFilter}
            onShow={onToggleFilter}
            onHide={onHideFilter}
          >
            {explorer[selectedExplorerOption].filterOptions}
          </SortFilter>           

          <SortFilter
            label="Sort"
            show={showSort}
            onShow={onToggleSort}
            onHide={onHideSort}
          >
            {explorer[selectedExplorerOption].sortOptions}
          </SortFilter> */}

          {/* <input
            type="file"
            name="file"
            id="upload-csv"
            accept=".csv"
            onChange={uploadWorkflow}
            style={{display: "none"}}
          />

          <label htmlFor="upload-csv" className="upload-icon">
            <UploadIcon />
          </label> */}

          <ApiSelector />
        
          <div className="user-options-container">
            <div className="user-container">
              <p>{account}</p>
            </div>
            <DownIcon />
          </div>
        </div>

        <div className="workflows-container">
          {explorer[selectedExplorerOption].isLoading ? (
            explorer[selectedExplorerOption].loadingView
          ) : (
            <>
              {explorer[selectedExplorerOption].component}
              {explorer[selectedExplorerOption].canLoadMore && (
                <p className="load-more-button" onClick={() => onLoadMore()}>Load More</p>
              )}
            </>
          )}
        </div>
        
      </div>
      <ExpiredTokenAlert show={showSignOut} onConfirm={onExpiredTokenConfirm} />
      <ToastContainer />
    </div>
  )
}

export default WorkflowFileExplorer
